module.exports = __webpack_public_path__ + "static/media/Lahore High Court Bar Association Library c. 1933.c1ab0006.jpg";